import React, { useEffect, useState } from 'react';
import './EmailManagement.css';
import Layout from '../components/Layout';
import { ADMIN_BASE_URL } from './config';
import { toast } from 'react-toastify';
import { set } from 'react-hook-form';


// const SENDGRID_TEMPLATES = [
//   { id: 'd-1234567890', name: 'Welcome Email' },
//   { id: 'd-0987654321', name: 'Commission Notification' },
//   { id: 'd-5555555555', name: 'Payment Confirmation' },
//   { id: 'd-6666666666', name: 'User Alert' },
//   { id: 'd-7777777777', name: 'Promotion Announcement' },
// ];

// const USERS = [
//   { id: 1, first_name: 'John', last_name: 'Doe', email: 'john@example.com', group: 'AI Attendees' },
//   { id: 2, first_name: 'Jane', last_name: 'Smith', email: 'jane@example.com', group: 'Free Members' },
//   { id: 3, first_name: 'Bob', last_name: 'Johnson', email: 'bob@example.com', group: 'Paid Members' },
//   { id: 4, first_name: 'Alice', last_name: 'Williams', email: 'alice@example.com', group: 'Verify Payment Users' },
//   { id: 5, first_name: 'Charlie', last_name: 'Brown', email: 'charlie@example.com', group: 'AI Attendees' },
//   { id: 6, first_name: 'Diana', last_name: 'Prince', email: 'diana@example.com', group: 'Free Members' },
// ];

const BY_GROUP = {
    AI_ATTENDEES: "Ai Attendees",
    FREE_MEMBERS: "Free Members",
    VERIFY_PAYMENT_USERS: "Verify Payment Users"
};

const GROUPS = ['AI Attendees', 'Free Members', 'Verify Payment Users'];

export default function EmailManagement() {
  const [users, setUsers] = useState([]);
  const [ai2Users, setAi2Users] = useState([]);
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [templateLoading, setTemplateLoading] = useState(false);

  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [recipientMode, setRecipientMode] = useState('all');
  const [selectedGroup, setSelectedGroup] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isrefreshing, setIsrefreshing] = useState(false);
  const [emailHistory, setEmailHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const isAdmin = localStorage.getItem('isAdmin') === '1';
  const isCallCenter = localStorage.getItem('isCallCenter') === '1';
  const isAdminUser = isAdmin || isCallCenter

  const filteredUsers = users.filter(user =>
    // user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.first_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getRecipientsForSend = () => {
    if (recipientMode === 'all') {
      return users;
    } else {
      return users.filter(u => selectedUsers.includes(u.id));
    }
  };

  const handleSendEmail = async () => {
    const recipients = getRecipientsForSend();

    // if (!selectedTemplate || recipients.length === 0) {
    //   toast.error('Please select a template and recipients');
    //   return;
    // }

    setIsLoading(true);
    const token = localStorage.getItem('token');

    // ✅ Build payload dynamically
    const payload = {
      tid: selectedTemplate,
    };

    if (recipientMode === 'all') {
      payload.send_to = 'ALL_USER';
    }

    if (recipientMode === 'group') {
      payload.send_to = 'BY_GROUP';
      payload.by_group = selectedGroup
        .toUpperCase()
        .replace(/\s+/g, '_');
    }

    if (recipientMode === 'individual') {
      payload.send_to = 'INDIVIDUAL';
      payload.users = recipients.map(u => u.id);
    }

    try {
      const res = await fetch(`${ADMIN_BASE_URL}/sendmail/send-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || 'Failed to send email');
      }
      toast.success(`Email sent to ${recipients.length} recipient(s)`);

      setShowConfirmation(false);
      setSelectedTemplate('');
      setSelectedUsers([]);
      setSelectedGroup('');
      setRecipientMode('all');

      fetchEmailHistory();

    } catch (error) {
      console.error(error);
      toast.error(error.message || 'Failed to send email');
    } finally {
      setIsLoading(false);
    }
  };



  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => setNotification(null), 4000);
  };

  const toggleUserSelection = (userId) => {
    setSelectedUsers(prev =>
      prev.includes(userId) ? prev.filter(id => id !== userId) : [...prev, userId]
    );
  };

  const handleReset = () => {
    setSelectedTemplate('');
    setRecipientMode('all');
    setSelectedGroup('');
    setSelectedUsers([]);
    setSearchTerm('');
  };

  const recipients = getRecipientsForSend();
  const template = templates.find(t => t.id === selectedTemplate);
  const refreshUsers = async () => {
    setLoading(true);
    const token = localStorage.getItem('token');

    try {
      const res = await fetch(`${ADMIN_BASE_URL}/sendmail/all-user`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || 'Failed to fetch users');
      }

      const allUsers = Array.isArray(data?.allUsers) ? data.allUsers : [];

      if (isAdminUser) {
        setUsers(allUsers);
        setAi2Users(allUsers.filter(u => u.role !== 'normal'));
      } else {
        // const filtered = allUsers.filter(u => u.role === 'normal');
        // setUsers(filtered);
        setUsers(allUsers);
        setAi2Users([]);
      }

    } catch (err) {
      console.error(err);
      setUsers([]);
      setAi2Users([]);
    } finally {
      setLoading(false);
    }
  };


  const fetchSendgridTemplates = async () => {
    const token = localStorage.getItem('token');
    setTemplateLoading(true);

    try {
      const res = await fetch(`${ADMIN_BASE_URL}/sendmail/fetch-templates`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || 'Failed to load templates');
      }

      setTemplates(Array.isArray(data?.allTemplates) ? data.allTemplates : []);
    } catch (err) {
      console.error(err);
      setTemplates([]);
      toast.error('Failed to load email templates');
    } finally {
      setTemplateLoading(false);
    }
  };

  const fetchEmailHistory = async () => {
    const token = localStorage.getItem('token');
    setHistoryLoading(true);
    setIsrefreshing(true);

    try {
      const res = await fetch(`${ADMIN_BASE_URL}/sendmail/email-history`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data?.message || 'Failed to fetch email history');
      }

      setEmailHistory(Array.isArray(data?.data) ? data.data : []);
    } catch (error) {
      console.error(error);
      setEmailHistory([]);
      // toast.error('Failed to load email history');
    } finally {
      setIsrefreshing(false);
      setHistoryLoading(false);
    }
  };
  const handlePreCheck = () => {
    const recipients = getRecipientsForSend();

    if (!selectedTemplate) {
      toast.error('Please select an email template');
      return;
    }

    if (recipientMode === 'group' && !selectedGroup) {
      toast.error('Please select a group');
      return;
    }

    if (recipientMode === 'individual' && !recipients.length) {
      toast.error('Please select at least one recipient');
      return;
    }

    setShowConfirmation(true);
  };


  useEffect(() => {
    refreshUsers();
    fetchSendgridTemplates();
    fetchEmailHistory();
  }, [isAdminUser]);

  return (
    <Layout>
      <div className="userlist-container" style={{ padding: 20, marginTop: 20 }}>
        <h2>Email Management</h2>

        <div className="email-management-wrapper">
          {/* Left Panel - Template & Recipient Selection */}
          <div className="left-panel">
            <div className="section">
              <h3>Select Email Template</h3>
              <select
                value={selectedTemplate}
                onChange={(e) => setSelectedTemplate(e.target.value)}
                className="form-select"
              >
                <option value="">-- Choose Template --</option>
                {templateLoading ? (
                  <option>Loading templates...</option>
                ) : (
                  templates.map(t => (
                    <option key={t.id} value={t.id}>
                      {t.name}
                    </option>
                  ))
                )}
              </select>
            </div>

            <div className="section">
              <h3>Select Recipients</h3>
              <div className="recipient-modes">
                <label className="radio-label">
                  <input
                    type="radio"
                    name="recipientMode"
                    value="all"
                    checked={recipientMode === 'all'}
                    onChange={(e) => setRecipientMode(e.target.value)}
                  />
                  All Users
                </label>
                <label className="radio-label">
                  <input
                    type="radio"
                    name="recipientMode"
                    value="group"
                    checked={recipientMode === 'group'}
                    onChange={(e) => setRecipientMode(e.target.value)}
                  />
                  By Group
                </label>
                <label className="radio-label">
                  <input
                    type="radio"
                    name="recipientMode"
                    value="individual"
                    checked={recipientMode === 'individual'}
                    onChange={(e) => setRecipientMode(e.target.value)}
                  />
                  Individual Users
                </label>
              </div>
            </div>

            {recipientMode === 'group' && (
              <div className="section">
                <h4>Select Group</h4>
                <select
                  value={selectedGroup}
                  onChange={(e) => setSelectedGroup(e.target.value)}
                  className="form-select"
                >
                  <option value="">-- Choose Group --</option>
                  {GROUPS.map(g => (
                    <option key={g} value={g}>{g}</option>
                  ))}
                </select>
              </div>
            )}

            {recipientMode === 'individual' && (
              <div className="section">
                <h4>Search Users</h4>
                <input
                  type="text"
                  placeholder="Search by name or email..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="form-input"
                />
                <div className="user-list">
                  {filteredUsers.length === 0 ? (
                    <div className="no-users">
                      No users found.
                    </div>
                  ) : (
                    filteredUsers.map(user => (
                      <label key={user.id} className="user-checkbox">
                        <input
                          type="checkbox"
                          checked={selectedUsers.includes(user.id)}
                          onChange={() => toggleUserSelection(user.id)}
                        />
                        <div>
                          <div className="user-name">
                            {user.first_name} {user.last_name}
                          </div>
                          <div className="user-email">{user.email}</div>
                        </div>
                      </label>
                    ))
                  )}
                </div>

              </div>
            )}

            <div className="section">
              <button
                onClick={handlePreCheck}
                disabled={isLoading}
                className="btn btn-primary"
              >
                {isLoading ? 'Sending...' : 'Send Email'}
              </button>
            </div>
          </div>

          {/* Right Panel - Preview & History */}
          <div className="right-panel">
            {/* Preview */}
            {template && (
              <div className="preview-section">
                <h3>Preview</h3>
                <div className="preview-box">
                  <div className="preview-header">
                    <strong>Template:</strong> {template.name}
                  </div>
                  <div className="preview-header">
                    <strong>Recipients:</strong> {recipients.length} user(s)
                  </div>
                  <div className="preview-content">
                    {recipientMode === 'all' && <p>All {recipients.length} users in the system</p>}
                    {recipientMode === 'group' && <p>All users in "{selectedGroup}" ({recipients.length})</p>}
                    {recipientMode === 'individual' && (
                      <>
                        <p>Selected users ({recipients.length}):</p>
                        <ul>
                          {recipients.map(u => (
                            <li key={u.id}>{u.name} - {u.email}</li>
                          ))}
                        </ul>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Email History */}
            <div className="history-section">
              <div className='history-header'>
                <h3 style={{marginBottom:0}}>Email Send History</h3>
                <button onClick={()=> fetchEmailHistory()} disabled={isrefreshing} className="btn btn-primary history-button">Refresh</button>
              </div>
              {historyLoading ? (
                <p>Loading history...</p>
              ) : emailHistory.length === 0 ? (
                <p className="no-history">No emails sent yet</p>
              ) : (
                <div className="history-table">
                  <div className="table-header">
                    <div>Date/Time</div>
                    <div>Template</div>
                    <div>Recipients</div>
                    <div>Success Count</div>
                    <div>Failed Count</div>
                    {/* <div>Status</div> */}
                  </div>

                  {emailHistory.map(entry => (
                    <div key={entry.id} className="table-row">
                      <div>
                        {new Date(entry.created_at).toLocaleString()}
                      </div>

                      <div>
                        {templates.find(t => t.id === entry.template_id)?.name || '—'}
                      </div>

                      <div>
                        {entry.recipient_type === 'ALL_USER'
                          ? 'All Users'
                          : entry.recipient_type === 'BY_GROUP'
                            ? BY_GROUP[entry.group_name] ? BY_GROUP[entry.group_name] : entry.group_name.replace(/_/g, ' ')
                            : 'Individual Users'}
                      </div>

                      <div>
                        {entry.success_count || 0} </div>
                      <div>
                        {entry.failed_count || 0}
                      </div>
                    </div>
                  ))}

                </div>
              )}
            </div>

          </div>
        </div>

        {/* Confirmation Modal */}
        {showConfirmation && (
          <div className="modal-overlay" onClick={() => setShowConfirmation(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h2>Confirm Email Send</h2>
              <div className="confirmation-details">
                <p><strong>Template:</strong> {template?.name}</p>
                <p><strong>Recipients:</strong> {recipients.length} user(s)</p>
                <p><strong>Type:</strong> {recipientMode === 'all' ? 'All Users' : recipientMode === 'group' ? selectedGroup : 'Individual Users'}</p>
              </div>
              <div className="modal-actions">
                <button onClick={() => setShowConfirmation(false)} disabled={isLoading} className="btn btn-secondary">
                  Cancel
                </button>
                <button onClick={handleSendEmail} disabled={isLoading} className="btn btn-primary">
                  {isLoading ? 'Sending...' : 'Confirm & Send'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}